import { render, staticRenderFns } from "./AccountTabGeo.vue?vue&type=template&id=221f8a3d"
import script from "./AccountTabGeo.vue?vue&type=script&lang=js"
export * from "./AccountTabGeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports